import { adminServerInstance } from "../axios/instances";
import { 
    GET_BRANCH_LIST, 
    GET_BRANCH_LIST_SUCCESS, 
    GET_BRANCH_LIST_FAIL,
    OPERATION_LOG,
    OPERATION_LOG_SUCCESS,
    OPERATION_LOG_FAIL
} from "../actions/types"
import {COMMON as type} from "./types";
import { execute } from "../network/executor";

export function operationLog(order_id, operator, operation_code, operation_type, description, memo) {   
    return function(dispatch) {
        dispatch({type: OPERATION_LOG})
        return adminServerInstance.post("/driver/insertoperationlog", {
            order_id: order_id,
            operator: operator,
            operation_code: operation_code,
            operation_type: operation_type,
            description: description,
            memo: memo
        })
        .then(({data}) => {
            dispatch({
                type: OPERATION_LOG_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: OPERATION_LOG_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getBranchList(){
    return function(dispatch){
        dispatch({type: GET_BRANCH_LIST})
        return adminServerInstance.get("/map/getbranchlist")
            .then(({data}) => {
                dispatch({
                    type: GET_BRANCH_LIST_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_BRANCH_LIST_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getAdvancedSearchList(branches, orderType, searchBy, paramValue, customer, extensionNo){
    return adminServerInstance.get("/map/getorderinfobypartnerandkey", {
            params: {
                partner_id: orderType,
                [searchBy]: paramValue,
                branch: branches,
                extension_no: extensionNo,
                customer_id: customer
            }
        }).then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            console.log(error)
            return Promise.reject(error);
        })
}

export const getAllUsers = () => (dispatch) => execute(dispatch)(
    adminServerInstance.get('/usermanagement/getalluser'),
    {
      type: type.GET_ALL_USERS,
      success: type.GET_ALL_USERS_SUCCESS,
      fail: type.GET_ALL_USERS_FAIL,
    }
);